import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styles from './GlobalModal.module.css';

const GlobalModal = ({ 
  show, 
  onClose, 
  title, 
  message, 
  children,
  primaryButtonText, 
  secondaryButtonText, 
  primaryButtonAction, 
  secondaryButtonAction,
  navigateTo,
  customClass,
  hideButtons
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!show) return null;

  const handlePrimaryAction = () => {
    if (navigateTo) {
      navigate(navigateTo);
    }
    if (primaryButtonAction) {
      primaryButtonAction();
    }
    if (!primaryButtonAction && !navigateTo) {
      onClose();
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div 
        className={`${styles.modalContent} ${customClass ? customClass : ''}`} 
        onClick={(e) => e.stopPropagation()}
      >
        {title && <h4>{title}</h4>}
        
        {message && <p>{message}</p>}
        
        {children && <div className={styles.modalChildren}>{children}</div>}
        
        {!hideButtons && (
          <div className={styles.modalButtons}>
            {secondaryButtonText && (
              <button
                onClick={secondaryButtonAction || onClose}
                className={styles.secondaryButton}
              >
                {secondaryButtonText || t('general.UI.cancel')}
              </button>
            )}
            {primaryButtonText && (
              <button
                onClick={handlePrimaryAction}
                className={styles.primaryButton}
              >
                {primaryButtonText || t('general.UI.ok')}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default GlobalModal; 